module.exports = __webpack_public_path__ + "static/tr-section-2@2x-9d9c644fa2846a19d046f42efa7e98ce.png";